import axios from "axios";
import { getNewToken, getToken, isTokenExpired } from "helpers/auth";
import defaultHeaders from "./default-headers";

export const createSavedSearches = async (sendEmail, title, url) => {
  if (isTokenExpired()) await getNewToken();
  const authorization = await getToken();
  const apiUrl = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/saved-search/`;

  const response = await axios.post(
    apiUrl,
    { sendEmail, title, url },
    {
      headers: {
        ...defaultHeaders,
        Authorization: authorization,
      },
    }
  );

  return response.data;
};
